$(document).on("submit", ".to-cart", function(e){
  e.preventDefault()

  $.ajax({
    url: $(this).attr("action"),
    data: $(this).serialize(),
    dataType: "json",
    type: "post",
    success: function(data){
      if (data.code == "error") {
        $("#cart-response").html(data.text)
      }else if (data.code == "success") {
        // $("#cart-response").html(data.text)
        $("#cart-count").html(data.cart_count)
        $("#cart-count-mobile").html(data.cart_count)
        $("#cart-sum").html(data.cart_sum)
        $(".shopping-cart").html(data.cart_view)

        swal({
          title: "Чудесно!",
          text: "Добавихте продукта в количката",
          icon: "success",
        });

        // setTimeout(function(){
        //   $("#cart-response").html('')
        // }, 2000)
      }
    }
  })
})
